import styled from "styled-components";

export const ButtonTitle = styled.p`
  font-family: ${({ theme }) => theme.fonts.button.family};
  font-size: ${({ theme }) => theme.fonts.button.fontSize};
  line-height: ${({ theme }) => theme.fonts.button.lineHeight};
  font-weight: ${({ theme }) => theme.fonts.button.fontWeight};
  letter-spacing: ${({ theme }) => theme.fonts.button.letterSpacing};
  max-width: ${({ theme }) => theme.copyMaxWidth};
  color: ${({ theme }) => theme.colors.typographyDefault};
`;
